// 江苏
export const PROVINCE_ID = 320000
// 南京
export const CITY_ID = 320100
// 付款方式
export const payTypeList = [
  {
    name: '货到付款',
    code: 1,
  },
  {
    name: '从COD中扣除',
    code: 2,
  }
]
